<template>
  <div class="ui-frame">
    <transition @enter="enterLogo" @leave="leaveLogo" appear :css="false">
      <div
        class="ui-frame__logo"
        :class="{ 'ui-frame__logo--app' : $inApp }"
        v-if="
          (isTouchDevice && $store.state.mode === 'loading')
          || (isTouchDevice && $store.state.mode === 'intro')
          || (isTouchDevice && $store.state.mode === 'pgSelection')
          || (isTouchDevice && $store.state.mode === 'timeExpired')
          || !isTouchDevice
        "
      >
        <AppLogo />
      </div>
    </transition>

    <transition @enter="enterUi" @leave="leaveUi" mode="out-in" :css="false">
      <Intro
        class="ui-section"
        data-phase="intro"
        v-if="$store.state.mode === 'intro'"
      />

      <PgSelection
        class="ui-section"
        data-phase="pgSelection"
        v-if="$store.state.mode === 'pgSelection'"
      />

      <Tutorial
        class="ui-section"
        data-phase="tutorial"
        v-if="$store.state.mode === 'tutorial'"
      />

      <Game
        class="ui-section"
        data-phase="game"
        v-if="$store.state.mode === 'playing'"
      />

      <Pause
        class="ui-section"
        data-phase="pause"
        v-if="$store.state.mode === 'paused'"
      />

      <TimeExpired
        class="ui-section"
        data-phase="timeExpired"
        v-if="$store.state.mode === 'timeExpired'"
      />

      <GameOver
        class="ui-section"
        data-phase="gameover"
        v-if="$store.state.mode === 'gameover'"
      />
    </transition>

    <ButtonCircular />
  </div>
</template>

<script>
import { gsap } from 'gsap';
import AppLogo from '@/components/AppLogo';
import ButtonCircular from '@/components/ButtonCircular';
import Intro from '@/components/UI/Intro';
import PgSelection from '@/components/UI/PgSelection';
import Tutorial from '@/components/UI/Tutorial';
import Game from '@/components/UI/Game';
import Pause from '@/components/UI/Pause';
import TimeExpired from '@/components/UI/TimeExpired';
import GameOver from '@/components/UI/GameOver';

import { isTouchDevice } from '@/scripts/utils';
import transition from '@/scripts/transitions';

export default {
  name: 'UIFrame',

  components: {
    AppLogo,
    ButtonCircular,
    Intro,
    PgSelection,
    Tutorial,
    Game,
    Pause,
    TimeExpired,
    GameOver,
  },

  data() {
    return {
      isTouchDevice: isTouchDevice(),
      firstEnter: true,
    };
  },

  mounted() {
    this.keydownHandler = (e) => this.keydown(e);
    window.addEventListener('keydown', this.keydownHandler);
  },

  methods: {
    enterUi(el, done) {
      const { phase } = el.dataset;
      if (phase === 'gameover') this.$sendEvent('End', 'game_over');

      transition.get(`${phase}-enter`)(el).then(done);
    },
    leaveUi(el, done) {
      const { phase } = el.dataset;
      transition.get(`${phase}-leave`)(el).then(done);
    },
    enterLogo(el, done) {
      gsap.from(el, {
        scale: 0.5,
        duration: 2,
        autoAlpha: 0,
        ease: 'elastic.out(0.5, 0.7)',
        delay: this.firstEnter ? 2 : 0,
        onComplete: done,
      });

      if (this.firstEnter) this.firstEnter = false;
    },
    leaveLogo(el, done) {
      gsap.to(el, {
        scale: 0,
        duration: 0.5,
        autoAlpha: 0,
        transformOrigin: '50% 35%',
        ease: 'power3.out',
        onComplete: done,
      });
    },
    keydown(e) {
      if (e.keyCode === 27 && (this.$store.state.mode === 'playing' || this.$store.state.mode === 'paused')) this.$eventHub.$emit(this.$store.state.mode === 'playing' ? 'pause' : 'resume');
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-frame {
  @include full(true);

  pointer-events: none;

  .ui-section {
    @include full(true);
  }

  &__logo {
    position: fixed;
    top: 10.5%;
    left: 50%;

    transform: translateX(-50%);

    &--app {
      z-index: 5;
    }

    @include mq($until: ipadP) {
      top: 7%;
    }
  }
}
</style>
